import { useCallback, useEffect, useRef } from 'react'
import { toast } from 'sonner'

// Mount inside a tenant-keyed boundary. Old completions cannot publish into a
// new clinic (including A → B → A); cleanup dismisses only this scope's toasts.
export function useScopedToast() {
  const alive = useRef(true)
  const ids = useRef(new Set<string | number>())
  useEffect(() => {
    alive.current = true
    const current = ids.current
    return () => {
      alive.current = false
      current.forEach((id) => toast.dismiss(id))
      current.clear()
    }
  }, [])
  return useCallback((kind: 'success' | 'error', message: string) => {
    if (!alive.current) return
    // Replace previous action feedback in this scope, rather than accumulating.
    ids.current.forEach((id) => toast.dismiss(id))
    ids.current.clear()
    ids.current.add(toast[kind](message))
  }, [])
}
